/**
 * Safety numbers: a short, human-comparable fingerprint of two users' device keys.
 * If both users see the same number, no one (including the server) has inserted a
 * device into their conversation. Order-independent, like Signal's.
 */
import { asBufferSource, concatBytes, utf8 } from './encoding.js';
async function fingerprint(userId, keys) {
    const sorted = [...keys].sort((a, b) => {
        for (let i = 0; i < Math.min(a.length, b.length); i++)
            if (a[i] !== b[i])
                return a[i] - b[i];
        return a.length - b.length;
    });
    let data = concatBytes(utf8.encode(`comms-safety-v1:${userId}:`), ...sorted);
    // Iterate to make brute-forcing a colliding key set expensive.
    for (let i = 0; i < 1024; i++) {
        data = new Uint8Array(await crypto.subtle.digest('SHA-512', asBufferSource(data)));
    }
    return data;
}
function digits(bytes) {
    const chunks = [];
    for (let i = 0; i < 30; i += 5) {
        const n = (bytes[i] * 2 ** 32 +
            bytes[i + 1] * 2 ** 24 +
            bytes[i + 2] * 2 ** 16 +
            bytes[i + 3] * 2 ** 8 +
            bytes[i + 4]) %
            100000;
        chunks.push(n.toString().padStart(5, '0'));
    }
    return chunks.join(' ');
}
export async function safetyNumber(a, b) {
    const [fa, fb] = await Promise.all([
        fingerprint(a.userId, a.deviceKeys),
        fingerprint(b.userId, b.deviceKeys),
    ]);
    const [first, second] = a.userId < b.userId ? [fa, fb] : [fb, fa];
    return `${digits(first)} ${digits(second)}`;
}
//# sourceMappingURL=safety.js.map